const STORAGE_KEY = 'carrier-guard-third-party-parent';

const readStore = () => {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : {};
    } catch {
        return {};
    }
};

export const getStoredParentThirdPartyId = (supplierId) => {
    if (!supplierId) {
        return null;
    }

    const store = readStore();
    return store[String(supplierId)] || null;
};

export const setStoredParentThirdPartyId = (supplierId, parentId) => {
    if (!supplierId) {
        return;
    }

    const store = readStore();

    if (!parentId) {
        delete store[String(supplierId)];
    } else {
        store[String(supplierId)] = String(parentId);
    }

    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
};
